import React from "react";
import { Badge } from "./ui/badge";

const labels = {
  open: { label: "Ouverte", cn: "bg-blue-100 text-blue-800 hover:bg-blue-100" },
  offered: { label: "Offres reçues", cn: "bg-amber-100 text-amber-800 hover:bg-amber-100" },
  accepted: { label: "Acceptée", cn: "bg-emerald-100 text-emerald-800 hover:bg-emerald-100" },
  in_progress: { label: "En cours", cn: "bg-orange-100 text-orange-800 hover:bg-orange-100" },
  completed: { label: "Terminée", cn: "bg-slate-900 text-white hover:bg-slate-900" },
  cancelled: { label: "Annulée", cn: "bg-red-100 text-red-700 hover:bg-red-100" },
};

export default function StatusBadge({ status }) {
  const { label, cn } = labels[status] || { label: status, cn: "bg-slate-100 text-slate-700" };
  return <Badge className={`${cn} rounded-full font-medium px-2.5 py-0.5`}>{label}</Badge>;
}

export const UrgencyBadge = ({ urgency }) => {
  const map = {
    low: { label: "Basse", cn: "bg-slate-100 text-slate-700" },
    medium: { label: "Moyenne", cn: "bg-amber-100 text-amber-800" },
    high: { label: "Haute", cn: "bg-orange-100 text-orange-800" },
    emergency: { label: "URGENCE", cn: "bg-red-600 text-white" },
  };
  const { label, cn } = map[urgency] || map.medium;
  return <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-bold tracking-wide uppercase ${cn}`}>{label}</span>;
};
